export default class KformBuilderOptionPathController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('~/scripts/services/model/node-service').NodeService} NodeService
	 */
	constructor($scope, NodeService) {
		$scope.options = {
			display: 'tree',
			mode:    'class',
		};

		$scope.addChild = (/** @type {any} */ child) => {
			$scope.component.kdata.type_kid = child.type_kid;
		};

		$scope.deleteChild = async (/** @type {any} */ parent) => {
			if (parent?.kid) {
				const nodeParent = await NodeService.load(parent.kid)
				if (nodeParent) {
					$scope.component.kdata.type_kid = nodeParent.type_kid;
				}
			}
		};

		$scope.updatePath = () => {
			if (!Array.isArray($scope.component.kdata.path)) {
				$scope.component.kdata.path = [];
			}
			$scope.component.kdata.path.length = 0;

			if (Array.isArray($scope.formComponentPath)) {
				$scope.component.kdata.path.push(...$scope.formComponentPath.map((/** @type {any} */ p) => ({
					kid:        p.kid,
					flow:       p.flow,
					linker_kid: p.linker_kid,
				})));
			}
		};
	}
}
